import KeenTracking from 'keen-tracking';
const client = new KeenTracking({
  projectId: process.env.REACT_APP_KEEN_PROJECT_ID,
  writeKey: process.env.REACT_APP_KEEN_WRITE_KEY
});
  
export default client;